// extracted by mini-css-extract-plugin
export default {"inlineAdWrapper":"_U-z","inlineTitle":"aV-z","sponsoredAdsWrapper":"bV-z","marketplaceRecosWrapper":"cV-z"};